<template>
  <div class="pcscan-container">
    <div class="layout-banner">
      <img
        class="pc-banner"
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/programme_img2.png"
        alt=""
      />
      <img
        src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/solution_scanner_banner_mobile.png"
        class="mobile-banner"
        alt=""
      />
      <div class="text-block">
        <div
          class="title wow fadeInUp"
          data-wow-duration="0.8s"
          data-wow-delay="0.2s"
        >
          光伏智能巡检方案
        </div>
        <div class="desc wow fadeInUp" data-wow-delay="0.5s">
          智能巡航、问题发现、组件消缺全流程闭环管理体系，无需预先建模，轻松一飞，系统自动建模识别分析，高效便捷
        </div>
      </div>
    </div>

    <div class="industry-block type-block">
      <div class="industry-title page-block-title">传统巡检模式分析及问题</div>
      <div class="industry-content pc-carousel">
        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvscan_problem_img1.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">传统人工巡检</div>
            <div class="desc">巡查周期长、成本高、安全风险高</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvscan_problem_img2.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">传统无人机巡检</div>
            <div class="desc">聘请专业飞手，门槛高、工作流程长、工作效率低</div>
          </div>
        </div>

        <div class="industry-item">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvscan_problem_img3.png"
            alt=""
          />
          <div class="text-block">
            <div class="title">物联网大数据监控</div>
            <div class="desc">无法实现隐忧预警和组件级故障定位</div>
          </div>
        </div>
      </div>
      <div class="mobile-carousel">
        <carousel></carousel>
      </div>
    </div>

    <!-- 解决思路及流程 -->
    <div class="solve-progress-block">
      <div class="solve-title page-block-title">解决思路</div>
      <div class="solve-desc page-block-desc">
        从飞行巡检、到平台的数据分析、再到定位缺陷并进行消缺处理，全流程的作业模式
      </div>
      <div class="solve-progress-content">
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/flow_img4_mobile.png"
          class="mobile-img"
          alt=""
        />
        <img
          class="pc-img"
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/flow_img3.png"
          alt=""
        />
      </div>
    </div>

    <div class="advantage-block">
      <div class="advantage-block-title page-block-title">我们的优势</div>

      <div class="advantage-content">
        <div class="tab-wrap">
          <div class="tab-bar">
            <div
              class="tab-item"
              @mouseover="activeFlag = '1'"
              :class="{ 'active-item': activeFlag == '1' }"
            >
              算法领先
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '2'"
              :class="{ 'active-item': activeFlag == '2' }"
            >
              高精度
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '3'"
              :class="{ 'active-item': activeFlag == '3' }"
            >
              高效率
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '4'"
              :class="{ 'active-item': activeFlag == '4' }"
            >
              零门槛
            </div>
            <div
              class="tab-item"
              @mouseover="activeFlag = '5'"
              :class="{ 'active-item': activeFlag == '5' }"
            >
              全电站类型
            </div>
          </div>
        </div>

        <!-- 高效 -->
        <div class="tab-content" v-if="activeFlag == '1'">
          <div class="tab-row">
            <div class="tab-row-left">
              <div class="tab-row-title" style="margin-top: 3.25rem">
                无需预先建模
              </div>
              <div class="tab-row-desc">
                依托焱图慧云自主知识产权的实景建模云平台，可将巡检采集的数据自动云端建模，解决分布式电站面积小、数量多、配置底图难的问题。
              </div>
            </div>
            <div class="tab-row-right">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage1.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 专业 -->
        <div class="tab-content" v-if="activeFlag == '2'">
          <div class="tab-row">
            <div class="tab-row-left">
              <div class="tab-row-title" style="margin-top: 3.25rem">
                定位更精准
              </div>
              <div class="tab-row-block-wrap">
                <div class="block-column">
                  <div class="column-value">厘米级</div>
                  <div class="column-desc">缺陷定位</div>
                </div>

                <div class="block-column">
                  <div class="column-value">2cm*2cm</div>
                  <div class="column-desc">最小识别缺陷</div>
                </div>

                <div class="block-column">
                  <div class="column-value">>95%</div>
                  <div class="column-desc">查准率</div>
                </div>
              </div>
            </div>
            <div class="tab-row-right">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage2.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <!-- 全面 -->
        <div class="tab-content" v-if="activeFlag == '3'">
          <div class="tab-row">
            <div class="tab-row-left">
              <div class="tab-row-title" style="margin-top: 3.25rem">
                巡检效率更高
              </div>
              <div class="tab-row-desc">
                利用无人机设备和处理平台进行高效巡检，是传统人工巡检效率的<span
                  >数十倍</span
                >
              </div>
            </div>
            <div class="tab-row-right">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage3.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <div class="tab-content" v-if="activeFlag == '4'">
        <div class="tab-row">
          <div class="tab-row-left">
            <div class="tab-row-title" style="margin-top: 3.25rem">
              操作使用零门槛
            </div>
            <div class="tab-row-desc">
              软硬件使用简单，无需专门培训，即可使用无人机开展巡检作业
            </div>
          </div>
          <div class="tab-row-right">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage4.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <!--  -->
    <div
      class="tab-content"
      v-if="activeFlag == '5'"
      style="margin-bottom: 6.3rem"
    >
      <div class="station-row">
        <div class="station-left">
          <div class="station-left-title">电站类型全面兼容</div>
          <div class="station-left-desc">
            支持平铺电站、斜铺电站、山地电站、单轴跟踪、多轴跟踪等。
          </div>
        </div>
        <div class="station-right">
          <div class="station-row-item">
            <div class="station-block">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img7.png"
                  alt=""
                />
              </div>
              <div class="station-title">平铺、斜铺电站</div>
            </div>

            <div class="station-block">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img8.png"
                  alt=""
                />
              </div>
              <div class="station-title">山地电站</div>
            </div>
          </div>
          <div class="station-row-item">
            <div class="station-block">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img9.png"
                  alt=""
                />
              </div>
              <div class="station-title">单轴跟踪</div>
            </div>

            <div class="station-block">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/advantage_img10.png"
                  alt=""
                />
              </div>
              <div class="station-title">多轴跟踪</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="station-row">
        <div class="station-block">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage5.png" alt="" />
          <div class="text">平铺、斜铺电站</div>
        </div>
        <div class="station-block">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage6.png" alt="" />
          <div class="text">山地电站</div>
        </div>
        <div class="station-block">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage7.png" alt="" />
          <div class="text">单轴跟踪</div>
        </div>
        <div class="station-block">
          <img src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/scan_advantage8.png" alt="" />
          <div class="text">多轴跟踪</div>
        </div>
      </div> -->
    </div>

    <div class="industry-block">
      <div class="industry-title page-block-title">双光识别更精准</div>
      <div
        class="industry-content"
        style="margin-bottom: 5.06rem; justify-content: center"
      >
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/light.gif"
          alt=""
        />
      </div>
    </div>

    <!-- 支持八大缺陷类型 -->
    <div class="industry-block fault-wrap" style="max-width: 100%">
      <div class="industry-title page-block-title">支持8大缺陷类型</div>
      <div class="fault-content">
        <div class="fault-row">
          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img1.png"
              alt=""
            />
            <div class="text">点状热斑</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img2.png"
              alt=""
            />
            <div class="text">全红热斑</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img3.png"
              alt=""
            />
            <div class="text">横条状热斑</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img4.png"
              alt=""
            />
            <div class="text">竖条状热斑</div>
          </div>
        </div>

        <div class="fault-row">
          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img5.png"
              alt=""
            />
            <div class="text">厚积尘</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img6.png"
              alt=""
            />
            <div class="text">遮挡</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img7.png"
              alt=""
            />
            <div class="text">鸟粪</div>
          </div>

          <div class="fault-block">
            <img
              src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/defect_img8.png"
              alt=""
            />
            <div class="text">破损</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 工作模式 -->
    <div class="industry-block mobile-pad">
      <div class="industry-title page-block-title">无人值守工作模式</div>
      <div class="work-type-desc page-block-desc">
        智能管理算法 ，实现少人值守甚至无人值守，定期自主巡检，数据可追溯
      </div>
      <div class="work-list">
        <div class="work-column">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/flow_icon1.png"
            alt=""
          />
          <div class="work-column-title">任务制定</div>
          <div class="work-column-desc">
            规划巡检任务，定时执行，自动放飞、收纳、充电，随时待命。
          </div>
        </div>

        <div class="work-column">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/flow_icon2.png"
            alt=""
          />
          <div class="work-column-title">自动起飞、巡航</div>
          <div class="work-column-desc">
            无人机按照既定巡检路线自动飞行，多场景自适应，航飞图像直播显示。
          </div>
        </div>

        <div class="work-column">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/flow_icon3.png"
            alt=""
          />
          <div class="work-column-title">智能分析</div>
          <div class="work-column-desc">
            对无人机巡检的结果进行分析处理，组件自动编号，智能生成缺陷数据集。
          </div>
        </div>

        <div class="work-column">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/flow_icon4.png"
            alt=""
          />
          <div class="work-column-title">精准消缺</div>
          <div class="work-column-desc">
            双光识别，厘米级定位，查准率95%以上，所有隐患一目了然。
          </div>
        </div>

        <div class="work-column">
          <img
            src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/flow_icon5.png"
            alt=""
          />
          <div class="work-column-title">报告输出</div>
          <div class="work-column-desc">
            一键生成报告，组件及定位，为运维人员提供数据支撑。
          </div>
        </div>
      </div>
      <div class="work-img-wrap">
        <img
          style="max-width: 70%"
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/work_scenario.png"
          alt=""
          class="pc-img"
        />
        <img
          src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/work_scenario_mobile.png"
          class="mobile-img"
          alt=""
        />
      </div>
    </div>

    <div class="related-product-wrap">
      <div class="related-product-title page-block-title">相关产品</div>
      <div class="related-product-list">
        <div
          class="related-product-card"
          v-for="(item, index) in productList"
          :key="index"
          @click="goProduct(item.path)"
        >
          <div class="related-product-img">
            <img :src="item.image" :alt="item.title" />
          </div>
          <div class="related-product-info">
            <div class="related-product-name">{{ item.title }}</div>
            <div class="related-product-desc">{{ item.desc }}</div>
          </div>

          <!-- 悬停二维码遮罩 -->
          <div
            class="related-product-mask"
            v-if="item.maskType === 'download-double'"
          >
            <div class="mask-title">扫码下载体验</div>
            <div
              class="mask-block"
              v-for="(code, cIndex) in item.codes"
              :key="cIndex"
            >
              <img :src="code.image" alt="" />
              <div>{{ code.label }}</div>
            </div>
          </div>
          <div
            class="related-product-mask mask-center"
            v-else-if="item.maskType === 'consult'"
          >
            <div class="mask-title">联系客服</div>
            <img :src="item.codeImage" alt="" />
            <div class="mask-label">扫码咨询</div>
          </div>
          <div
            class="related-product-mask mask-center"
            v-else-if="item.maskType === 'download-single'"
          >
            <div class="mask-title">扫码下载体验</div>
            <img :src="item.codeImage" alt="" />
            <div class="mask-label">{{ item.codeLabel }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-bottom-space"></div>
  </div>
</template>

<script>
import carousel from "./components/pvscan-carousel.vue";
import { WOW } from "wowjs";

export default {
  components: {
    carousel,
  },
  data() {
    return {
      activeFlag: "1",
      productList: [
        {
          title: "巡检精灵",
          desc: "根据作业范围及电站类型，控制无人机自主巡检作业，垂直光伏组件，温度数据更精准，适配所有电站类型。",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile_product_pvs.png",
          path: "/product/mobile-inspection",
          maskType: "download-double",
          codes: [
            {
              image:
                "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvs_mobile_code.png",
              label: "巡检精灵",
            },
            {
              image:
                "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvs_mobile_code.png",
              label: "巡检精灵（遥控器版）",
            },
          ],
        },
        {
          title: "光伏一点通-分布式巡检平台",
          desc: "依托焱图云平台，将巡检数据自动云端建模及缺陷分析，无需预先建模，重新定义光伏巡检新形态。",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/product_pvs.png",
          path: "/product/pvscan",
          maskType: "consult",
          codeImage:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/business_code_noboder.png",
        },
        {
          title: "光伏一点通-无人值守巡检平台",
          desc: "无人机+机库7x24小时在线，随时待命，收到定期或即时任务，自动飞行作业、上传数据及智能隐患分析，让电站巡检无忧。",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/auto-inspection_product.png",
          path: "/product/auto-solar-sentry",
          maskType: "consult",
          codeImage:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/index/business_code_noboder.png",
        },
        {
          title: "去消缺",
          desc: "即时获取隐患消缺任务，地图导航引导缺陷定位，提供建议消缺方式，并记录消缺实况，让消缺工作更高效。",
          image:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/fault_full_product.png",
          path: "",
          maskType: "download-single",
          codeImage:
            "https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/pvs_mobile_code.png",
          codeLabel: "去消缺APP",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      new WOW().init();
    });
  },
  methods: {
    goProduct(path) {
      if (path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.pcscan-container {
    width:100%;
    .mobile-carousel {
        display:none;
    }
    @keyframes zoomIn {
            0% {
              transform: scale(1.1);
            }
            100% {
                transform: scale(1);
            }
        }
    .layout-banner {
        height:100vh;
        position:relative;
        img {
          height:100%;
          width: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          transition: transform 0.3s ease-out;
          animation: zoomIn 3s ease-out forwards;

        }
        .text-block {
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%,-50%);
            z-index: 2;
            color:#fff;
            text-align:center;
            .title {
                font-size:3rem;
                letter-spacing: 2px;
                font-weight: bold;
                margin-bottom:1.44rem;
            }
            .desc {
                letter-spacing: 2px;
                width:734px;
                white-space: wrap;
                font-size:1.25rem;
                line-height:35px;
            }
        }
    }
    .type-block {
        margin-top:5rem !important;
    }

    .industry-block {
      max-width:var(--main-width);
      width:84%;
        margin:0 auto 4.93rem;
        .industry-title {
            position:relative;
            position:relative;
            text-align:center;
        }
    .industry-content {
        display:flex;
        margin-top:3.125rem;
        flex-wrap:wrap;
        justify-content:space-between;
        .industry-item {
            width:30%;
            // margin-right:33px;
            img {
                margin-bottom:0.875rem;
                width:100%;
            }
            .text-block {
                text-align:center;
                .title {
                    font-size:1.375rem;
                    font-weight:bold;
                    margin-bottom:10px;
                }
                .desc {
                 color:#666666;
                 font-size:14px;
                }
            }
        }
    }
    }

    .solve-progress-block {
        // height: 708px;
        background-size:cover;
        padding:1.375rem 0 2.8rem;
        margin:0 auto;
        color:#fff;
        background: linear-gradient( 180deg, rgba(206,228,255,0) 0%, #EFF4FF 100%);
        .solve-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:1.875rem;
            color:#333;
        }
    .solve-desc {
        text-align: center;
        margin:0 auto;
        letter-spacing: 1px;
        line-height:25px;
    }
    .solve-progress-content {
        max-width: var(--main-width);
        width: 84%;
        margin:3.68rem auto 0;
        display:flex;
        justify-content:center;
        .mobile-img {
          display:none;
        }
        .pc-img {
          width:86%;
          height:auto;
        }
    }
    }

    .advantage-block {
        margin:3.8rem auto 6.3rem;
        .advantage-block-title {
            position:relative;
            text-align:center;
            letter-spacing:1px;
            margin-bottom:4.93rem;
        }
    .tab-wrap {
        border-bottom:1px solid #DADADA;
        margin-bottom:3.6rem;
        padding-bottom:18px;
        white-space:nowrap;
        .tab-bar {
       display:flex;
       max-width:var(--main-width);
       width:84%;
       margin:0 auto;
       .tab-item {
        margin-right:9.68rem;
        font-size:1.5rem;
        font-weight:bold;
        letter-spacing: 1px;
        color:#333;
        cursor:pointer;
       }
       .active-item {
        color:#2372E9;
        position:relative;
       }
       .active-item::after {
        position:absolute;
        width:96px;
        height: 7px;
        left: 50%;
        transform:translateX(-50%);
        bottom: -24px;
        background-repeat: no-repeat;
        content:"";
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/titlle_line.png")
       }
    }
    }
    .tab-content {
      max-width:var(--main-width);
      width:84%;
        margin:0 auto;
        .tab-row {
            display:flex;
            .tab-row-left {
                flex:1;
                .tab-row-title {
                    font-size:1.5rem;
                    margin-bottom:1.687rem;
                    font-weight:bold;
                }
                .tab-row-desc {
                    color:#666;
                    line-height:25px;
                    width:28.68rem;
                    span {
                        color:#2372E9;
                    }
                }
                .tab-row-block-wrap {
                    display:flex;
                    width:60%;
                    justify-content:space-between;
                    .column-value {
                        color:#2372E9;
                        font-size:1.25rem;
                        margin-bottom:10px;
                    }
                    .column-desc {
                        color:#666666;
                    }
                }
            }
            .tab-row-right {
                flex:1;
            }
        }

    }
    }
    .station-row {
            display:flex;
            max-width: var(--main-width);
            width: 84%;
            justify-content:space-between;
            margin:0 auto;
            .station-left {
              .station-left-title {
                font-size:2rem;
                margin-bottom:1.75rem;
              }
              .station-left-desc {
                font-size:1rem;
                color:#666666;
              }
            }
            .station-right {
              flex:1;
              .station-row-item {
                display:flex;
                justify-content:right;
                .station-block {
                  position:relative;
                  color:#fff;
                  margin-right:1rem;
                  margin-bottom:0.8rem;
                }
                .img-wrap {
                  width:17.5rem;
                  img {
                    width:100%;
                  }
                }
                .station-title {
                  position: absolute;
                  bottom: 20px;
                  text-align:center;
                  width:100%;
                }
              }
            }
        }
        .fault-wrap {
            width:100%;
            background-color:#F5F7FA;
            padding:3.812rem 0 1.625rem;
            .fault-content {
              max-width:var(--main-width);
               width:84%;
                margin:2.875rem auto 0rem;
              .fault-row {
                display:flex;
                overflow-x:auto;
                justify-content:center;
                gap:2rem;
                margin-bottom:2rem;
            .fault-block {
                position:relative;
                text-align:center;
                font-size:1.25rem;
                flex:1;
                .text {
                    margin-top:20px;
                }
                img {
                  width:100%;
                  height:auto;
                }
            }
            .fault-block:not(:last-child) {
                // margin-right:2.312rem;
            }
        }

        }
        }
        .work-type-desc {
            color:#666666;
            margin-bottom:2.75rem;
            text-align:center;
            margin-top:1.87rem;
        }
        .work-list {
            display:flex;
            margin-top:7.9rem;
            justify-content:space-between;
            margin-bottom:5.3rem;
            flex-wrap:wrap;
            width:100%;
            .work-column {
                width:13.5rem;
                height:13.125rem;
                min-width:10rem;
                // margin-right:2.75rem;
                padding:4rem 1.1rem;
                box-sizing:border-box;
                cursor:pointer;
                transition:all 0.3s;
                position:relative;
                background:linear-gradient( 180deg, #F3FCFF 0%, #F5F9FF 100%);
              img {
                position:absolute;
                top:-61px;
                left:50%;
                transform:translateX(-50%);
              }
              .work-column-title {
                font-size:1.375rem;
                text-align:center;
                color:#333;
                font-weight:bold;
                margin-bottom:0.75rem;
              }
              .work-column-desc {
                color:#666666;
                line-height:24px;
                font-size:14px;
                text-align:center;
              }
            }
            .work-column:not(:last-child) {
                // margin-right:2.75rem;
            }
            .work-column:hover {
                transform:translateY(-21px);
                .work-column-title {
                    color:#2372E9;
                }
            }
        }
        .work-img-wrap {
            display:flex;
            justify-content:center;
            align-items:center;
            .pc-img {
               display:block;
              }
              .mobile-img {
                display:none;
              }
        }
        .related-product-wrap {
            background-color:#F5F7FA;
            width:100%;
            padding:3rem 0 6rem;

            .related-product-title {
                text-align:center;
                margin-bottom:3rem;
            }

            .related-product-list {
                max-width:68.75rem;
                width:72%;
                margin:0 auto;
                display:grid;
                grid-template-columns:1fr 1fr;
                gap:3.75rem 4.6rem;
            }

            .related-product-card {
                background:#fff;
                border-radius:4px;
                overflow:hidden;
                cursor:pointer;
                display:flex;
                flex-direction:column;
                aspect-ratio:440 / 480;
                position:relative;
                box-shadow:0 2px 12px rgba(0, 0, 0, 0.04);
                transition:transform 0.25s ease, box-shadow 0.25s ease;

                &:hover {
                    transform:translateY(-4px);
                    box-shadow:0 8px 24px rgba(0, 0, 0, 0.08);

                    .related-product-info {
                        .related-product-name {
                            color:#2372E9;
                        }
                    }

                    .related-product-mask {
                        height:100%;
                        padding:1.25rem 1rem;
                    }
                }

                .related-product-img {
                    width:100%;
                    flex:1;
                    min-height:0;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    background:#fff;
                    padding:1.25rem 1.5rem 0;
                    box-sizing:border-box;

                    img {
                        width:100%;
                        height:100%;
                        object-fit:contain;
                    }
                }

                .related-product-info {
                    flex-shrink:0;
                    padding:1rem 1.75rem 1.75rem;
                    box-sizing:border-box;

                    .related-product-name {
                        font-size:1.25rem;
                        font-weight:bold;
                        color:#333;
                        margin-bottom:0.75rem;
                        line-height:1.4;
                        transition:color 0.25s ease;
                    }

                    .related-product-desc {
                        font-size:0.875rem;
                        color:#666;
                        line-height:1.6rem;
                    }
                }

                    .related-product-mask {
                    position:absolute;
                    top:0;
                    left:0;
                    width:100%;
                    height:0;
                    overflow:hidden;
                    background-color:#2372E9;
                    color:#fff;
                    text-align:center;
                    transition:height 0.3s ease;
                    box-sizing:border-box;
                    padding:0;
                    z-index:2;
                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;

                    .mask-title {
                        margin:0.5rem 0 1rem;
                        font-size:1.25rem;
                        font-weight:bold;
                    }

                    .mask-block {
                        text-align:center;
                        margin-bottom:1rem;

                        &:last-child {
                            margin-bottom:0;
                        }

                        img {
                            width:7.5rem;
                            display:block;
                            margin:0 auto;
                            background:#fff;
                        }

                        div {
                            margin-top:0.5rem;
                            font-size:0.875rem;
                        }
                    }

                    &.mask-center {
                        .mask-title {
                            margin:0 0 1.25rem;
                        }

                        img {
                            width:9rem;
                            background:#fff;
                        }

                        .mask-label {
                            margin-top:0.875rem;
                            font-size:1rem;
                        }
                    }
                }
            }
        }

        .page-bottom-space {
            width:100%;
            height:10.18rem;
            background:#fff;
        }
}
@media only screen and (max-width: 1200px) and (min-width: 768px) {
    .industry-content {
        .industry-item {
            margin-bottom:30px;
        }
    }
    .work-list {
        .work-column {
            margin-bottom:80px;
        }
    }
}
@media only screen and (max-width: 768px) {
  .advantage-block-title {
    font-size:22px !important;
    font-weight:bold;
  }
  .advantage-block-title::after {
    top:45px !important;
  }
  .industry-block {
    .industry-title {
      margin:40px 0 14px;
    }
    .industry-content {
      margin-top:0;
        .industry-item {
            margin-bottom:30px;
        }
    }
    }

    .pcscan-container {
      .layout-banner {
      height:380px !important;
      margin-top:108px;

      .text-block {
        margin-top:0 !important;
        width:80%;
        .title {
          font-size:24px;
          margin-bottom:10px;
        }
        .desc {
          width:100%;
          font-size:1.125rem;
          line-height:19px;
        }
      }
      }
        .industry-block {
        width:auto ;
        padding-bottom:33px;
        margin:0 auto 0;
      }
    }
    .pcscan-container {
    .type-block {
        margin-top:30px !important;
    }
    .industry-title {
      font-size:22px !important;
      margin-top:0px !important;
      font-weight:bold;
    }
    .mobile-pad {
      .industry-title {
        padding-top:26px;
      }
      .industry-title::after {
        top:70px !important;
      }
    }
    .industry-title::after {
      top:45px !important;
    }
    .industry-content {
        margin-top:30px !important;
       margin-bottom:0 !important;

    }
    .pc-carousel{
       display:none !important;
    }
    .mobile-carousel {
      display:block !important;
    }
    .solve-progress-block {
      height:940px !important;
      // background-size:contain !important;
      background-repeat:no-repeat;
      background-position: center;
      .solve-progress-content {
         .mobile-img {
          display:block !important;
        }
        .pc-img {
          display:none;
        }
      }
      .solve-title {
        font-size:22px !important;
        margin-top:0px !important;
        font-weight:bold;
    }
    .solve-desc {
      width:80%;
    }
    .solve-title::after {
      top:50px !important;
    }
}
.tab-content {
  width: 100% !important;
  box-sizing: border-box;
}
.advantage-block {
  margin-bottom:43px !important;
}
.advantage-content,.tab-content {
    padding:0 10px;
    .active-item::after {
      background-color:#2372e9 !important;
      height:3px !important;
      bottom:-20px !important;
    }
    .tab-wrap {
      overflow-x:auto !important;
      margin-bottom:18px !important;
    }
    .tab-row-title {
      margin-top:0px !important;
    }

    .tab-bar {
      height:30px;
        // overflow-x:auto;
        // overflow-y:hidden;
        width:auto !important;
        .tab-item {
            white-space:nowrap !important;
            margin-right:20px !important;
        }
     }
     .tab-row {
        display:block !important;
        .tab-row-desc,.tab-row-block-wrap {
            margin-bottom:10px !important;
        }
        .tab-row-desc {
          width: auto !important;
          line-height:19px !important;
        }
        .tab-row-right {
          height:213px;
          img {
            height:100%;
          }
        }
     }
    }
    .related-product-wrap {
      padding:30px 15px 40px;

      .related-product-title {
        margin-bottom:20px;
      }

      .related-product-list {
        width:100%;
        max-width:none;
        grid-template-columns:1fr;
        gap:16px;
      }

      .related-product-card {
        aspect-ratio:auto;

        .related-product-img {
          padding:12px 12px 0;
          flex:none;
          aspect-ratio:440 / 480;
        }

        .related-product-info {
          padding:12px 16px 20px;

          .related-product-name {
            font-size:1.125rem;
          }
        }
      }
    }

    .page-bottom-space {
      height:52px;
    }

    }
    .station-row {
        flex-wrap:wrap;
        justify-content:space-around;
        width:auto !important;
        .station-right {
          margin-top:10px;
        .station-row-item {
        justify-content:left !important;
    .station-block {
        width:45% !important;
        margin-bottom:5px;
        height:auto !important;
        .img-wrap {
          width:14.5rem !important;
          margin-right:7px;
        }
        img {
            width:100%;
        }
        .text {
            bottom:50px !important;
        }
    }
  }
}
}
.fault-content {
  width:auto !important;

.fault-row {
    justify-content: space-around !important;
.fault-block {
    img {
        width:142px !important;
    }
    .text {
        margin-top:10px !important;
        font-size:16px !important;
    }
}
}
}

.work-type-desc {
    display:none;
}

.pcscan-container {
.work-list {
    margin:100px 15px  0 ;
    width:calc(100% - 30px);
     flex-wrap:wrap;
        .work-column {
            margin-bottom:100px;
        }
    .work-column {
        width:100%;
        height:140px;
        margin-right:0;
        position:relative;
        .work-column-title {
            text-align:left;
        }
        .work-column-desc {
            text-align:left;
        }
    }
    .work-column:nth-child(2n - 1) {
        img {
            right:16px !important;
            left:auto !important;
            width:78px !important;
            top:-42px !important;
            transform:auto !important;
        }
    }
    .work-column:not(:last-child):nth-child(2n - 1)::after {
        content:"";
        position:absolute;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile/arrow.png");
        width:15px;
        right:60px;
        height:33px;
        top:170px;
    }
    .work-column:not(:last-child):nth-child(2n)::after {
        content:"";
        position:absolute;
        background-image:url("https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/solution/mobile/arrow.png");
        width:15px;
        left:60px;
        height:33px;
        top:170px;
    }
    .work-column:nth-child(2n) {
        img {
            left:16px !important;
            width:78px !important;
            top:-42px;
            transform:translateX(0) !important;
        }
    }
}
}
.work-img-wrap {
     .pc-img {
        display:none !important;
      }
      .mobile-img {
        display:block !important;
      }
}
}
</style>
